import { Form } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import type { SettingsParamsType } from '@econtractor/types';
import ParamSwitch from '../ParamSwitch';
import { getCurrencyI18nParams } from 'utils/helpers/currency/currencyHelpers';

type CurrencyTabProps = {
    params: SettingsParamsType;
    isSaving: boolean;
    setParam: <K extends keyof SettingsParamsType>(key: K, value: SettingsParamsType[K]) => void;
};

const CurrencyTab = ({ params, isSaving, setParam }: CurrencyTabProps) => {
    const { t } = useTranslation(['Settings']);

    return (
        <div className="main-settings-fields">
            <ParamSwitch
                id="param-usdDefault"
                label={t('mainParams.fields.usdDefault.label', getCurrencyI18nParams())}
                description={t(
                    'mainParams.fields.usdDefault.description',
                    getCurrencyI18nParams(),
                )}
                checked={params.usdDefault}
                disabled={isSaving}
                onChange={(v) => setParam('usdDefault', v)}
            />

            <div className="border-top">
                <ParamSwitch
                    id="param-vatDefault"
                    label={t('mainParams.fields.vatDefault.label')}
                    description={t('mainParams.fields.vatDefault.description')}
                    checked={params.vatDefault}
                    disabled={isSaving}
                    onChange={(v) => setParam('vatDefault', v)}
                />
            </div>

            <div className="d-flex justify-content-between align-items-start gap-3 py-3 border-top">
                <div className="pe-2" style={{ maxWidth: 520 }}>
                    <div className="fw-semibold">{t('mainParams.fields.vatPercent.label')}</div>
                    <div className="text-muted fs-12 mt-1">
                        {t('mainParams.fields.vatPercent.description')}
                    </div>
                </div>
                <div
                    className="d-flex align-items-center gap-2 flex-shrink-0"
                    style={{ width: 110 }}
                >
                    <Form.Control
                        type="number"
                        min={0}
                        max={100}
                        step={0.1}
                        size="sm"
                        disabled={isSaving}
                        value={params.vatPercent}
                        onChange={(e) => {
                            const next = Number(e.target.value);
                            setParam('vatPercent', Number.isFinite(next) ? next : 0);
                        }}
                    />
                    <span className="text-muted">%</span>
                </div>
            </div>
        </div>
    );
};

export default CurrencyTab;
